/**
 * Created by jiachenpan on 16/11/18.
 */
// const validate = require('validate.js')
// 深度克隆
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}
// 判断是否为空
export function isEmpty(val) {
  if (!val && val !== 0) return true
  if (val === undefined) return true
  if (val instanceof Date) return false
  if (typeof val === 'object') return Object.keys(val).length === 0
  if (typeof val === 'string') return val == null || val.length === 0

  return false
}

export function isNotEmpty(val) {
  return !isEmpty(val)
}

// 验证手机号
export function isPhone(val) {
  return isNotEmpty(val) && val.length === 11 && parseInt(val) > 12999999999 && val < 19999999999
}
/**
 * 保留小数方法
 * @param {String} val
 * @param {Number} count
 * count为保留几位
 */
export function keepDecimals(val, count) {
  count = isEmpty(count) ? 2 : count
  const decimal = Math.pow(10, count)
  return Math.floor(Math.abs(parseFloat(val) * decimal)) / decimal
}
// 写cookies
export function setCookie(name, value) {
  var days = 1
  var exp = new Date()
  exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = name + '=' + escape(value) + ';path=/;expires=' + exp.toGMTString()
}
// 获取时间字符串
export function getDate(data) {
  let seperator1 = '-'
  let date = new Date(data)
  let year = date.getFullYear()
  let strDate = date.getDate()
  let month = date.getMonth() + 1
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  return year + seperator1 + month + seperator1 + strDate
}
/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName]
    var part = encodeURIComponent(propName) + '='
    if (value !== null && value !== '' && typeof value !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== '' && typeof value[key] !== 'undefined') {
            let params = propName + '[' + key + ']'
            var subPart = encodeURIComponent(params) + '='
            result += subPart + encodeURIComponent(value[key]) + '&'
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&'
      }
    }
  }
  return result
}

// 验证是否为blob格式
export async function blobValidate(data) {
  try {
    const text = await data.text()
    JSON.parse(text)
    return false
  } catch (error) {
    return true
  }
}
// 格式化购买人数
export function tranNumber(value, point) {
  if (!value) return 0
  let numStr = value.toString()
  let num = ''
  if (numStr.length < 5) {
    num = numStr
  } else if (numStr.length > 4 && numStr.length < 9) {
    let decimal = numStr.substring(numStr.length - 4, numStr.length - 4 + point)
    num = parseFloat(parseInt(value / 10000) + '.' + decimal) + 'w'
  } else if (numStr.length > 8) {
    let decimal = numStr.substring(numStr.length - 8, numStr.length - 8 + point)
    num = parseFloat(parseInt(value / 100000000) + '.' + decimal) + '亿'
  }
  return num
}
// 格式化时间
export function countdownTime(time) {
  let d = Math.floor(time / 1000 / 60 / 60 / 24)
  let h = Math.floor((time / 1000 / 60 / 60) % 24)
  let m = Math.floor((time / 1000 / 60) % 60)
  let s = Math.floor((time / 1000) % 60)
  return {
    day: d < 10 ? '0' + d : d,
    hou: h < 10 ? '0' + h : h,
    min: m < 10 ? '0' + m : m,
    second: s < 10 ? '0' + s : s
  }
}



// WEBPACK FOOTER //
// ./src/utils/validate.js